import {Route, Routes} from "react-router-dom";

import AdminContractsListSection from "./sections/adminContractsListSection";
import AdminContractsInfoSection from "./sections/adminContractsInfoSection";
import CustomerContractsListSection from "./sections/customerContractsListSection";
import CustomerContractsInfoSection from "./sections/customerContractsInfoSection";

function ContractsApp() {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <Routes>
            {!data.isCustomer ? (
                <>
                    <Route path="/" element={<AdminContractsListSection/>}/>
                    <Route path='/:id/info' element={<AdminContractsInfoSection/>}/>
                </>
            ) : (
                 <>
                     <Route path="/" element={<CustomerContractsListSection/>}/>
                     <Route path='/:id/info' element={<CustomerContractsInfoSection/>}/>
                 </>
             )}
        </Routes>
    );
}

export default ContractsApp;
